import { socket } from "../../services/socket";

const ENABLE_DEBUG = true;

export function useWebsocket() {
  function emit(key, data) {
    socket.emit(key, data);
    if (ENABLE_DEBUG) console.log(key, data);
  }

  function listen(key, callback) {
    socket.on(key, (dataSocket) => {
      if (ENABLE_DEBUG) console.log(key, dataSocket);
      callback(dataSocket);
    });
  }

  return { emit, listen };
}
